import { Vehicle } from 'api/types'

export const calculatePrice = (vehicle: Vehicle, vehicleCount: number) =>
  vehicle.price.total * vehicleCount
